import { createAsyncThunk } from "@reduxjs/toolkit";

import magnifiAPI from "../../services/api/magnifi";

export const fetchAllPlans = createAsyncThunk("plans/getPlans", async () => {
  try {
    const response = await magnifiAPI.getPlans();
    return response?.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});
export const addPlan = createAsyncThunk("plans/addPlan", async (payload) => {
  try {
    const response = await magnifiAPI.addPlan(payload);
    return response?.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});
export const modifyPlan = createAsyncThunk("plans/modifyPlan", async (payload) => {
  try {
    const response = await magnifiAPI.modifyPlan(payload);
    return response?.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});
export const deletePlan = createAsyncThunk("plans/deletePlan", async (payload) => {
  try {
    const response = await magnifiAPI.deletePlan({ payload });

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});
